module.exports = __webpack_public_path__ + "static/media/Contributions-income.4bf5e76c.png";